import { useContext } from 'react';
import {
    UnassignedAlertsContext,
    UnassignedAlertsContextData
} from './context';

export function useUnassignedAlerts(): UnassignedAlertsContextData {
    const data = useContext<UnassignedAlertsContextData | undefined>(
        UnassignedAlertsContext
    );

    if (!data) {
        throw new Error(
            "UnassignedAlertsContextData unavailable. Are you sure you're using this in a nested component of an UnassignedAlertsProvider?"
        );
    }

    return data;
}
